// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"e2c482ff","71":"9fa73ff5","165":"6979f55a","185":"0e37e5d3","220":"b3bb1524","287":"32edf832","333":"1306eff2","361":"071d58e2","440":"35f25287","453":"841ad29a","481":"fe566755","625":"f8564c16","926":"3282e534","967":"37d4918d","972":"fb66ab03"}[chunkId] + ".chunk.js";
};